import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { publishMetric } from '~/lib/metrics';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

interface options {
  /** Analytics `location` for the `account_signin` event. */
  location?: string;
  /** Metrics `section` tag. */
  section?: string;
}

/**
 * Starts an OIDC sign-in in the TOP window.
 *
 * `location`/`section` are parameterised because the caller is what the report is about: a
 * subscriptions sign-in filed under 'checkout' silently rewrites what that funnel means.
 */
const useSignIn = ({ location = 'checkout', section = 'checkout' }: options = {}) => {
  const { track } = useSmartSendAnalytics();
  const { signinRedirect } = useAuth();

  /**
   * @param returnUrl where to land after the round trip - defaults to the current page.
   *   `routes/signin.tsx` reads this back off `user.state` and assigns it to `window.location`.
   */
  const onSignInClick = useCallback(
    (returnUrl: string = window.location.href) => {
      track({
        type: 'account_signin',
        payload: {
          location
        }
      });
      publishMetric('account_signin', 1, { section });
      signinRedirect({ state: returnUrl });
    },
    [signinRedirect, track, location, section]
  );

  return {
    onSignInClick
  };
};
export default useSignIn;
